import axios from 'axios';
import { API_BASE } from '../config';

// گرفتن هدر احراز هویت
const getToken = () => localStorage.getItem("token");

const authHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// هندل خطای مشترک
const handleError = (err, customMessage) => {
  console.error(
    `❌ ${customMessage}:`,
    err.response?.data || err.message || err
  );

  // خطای سرور را برای لایه بالاتر پاس بده
  throw err;
};

/**
 * گرفتن لیست بیماران با فیلتر
 */
export const fetchSubjects = async (params = {}) => {
  const token = getToken();
  if (!token) {
    const error = new Error("بدون توکن — ابتدا وارد شوید.");
    error.code = "NO_TOKEN";
    throw error;
  }

  try {
    const res = await axios.get(`${API_BASE}subjects`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data;
  } catch (err) {
    handleError(err, "خطا در دریافت لیست بیماران");
  }
};

/**
 * گرفتن یک بیمار
 */
export const fetchSubjectById = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}subjects/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    handleError(err, "خطا در دریافت اطلاعات بیمار");
  }
};

/**
 * ساخت بیمار جدید
 */
export const createSubject = async (payload) => {
  try {
    const res = await axios.post(`${API_BASE}subjects`, payload, authHeaders());
    return res.data;
  } catch (err) {
    handleError(err, "خطا در ساخت بیمار جدید");
  }
};

/**
 * ویرایش بیمار
 */
export const updateSubject = async (id, payload) => {
  try {
    const res = await axios.put(`${API_BASE}subjects/${id}`, payload, authHeaders());
    return res.data;
  } catch (err) {
    handleError(err, "خطا در ویرایش بیمار");
  }
};

/**
 * حذف بیمار
 */
export const deleteSubject = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}subjects/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    handleError(err, "خطا در حذف بیمار");
  }
};

/**
 * گرفتن پاسخ‌های فرم برای یک بیمار
 */
export const fetchSubjectResponses = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}subjects/${id}/responses`, authHeaders());
    return res.data;
  } catch (err) {
    handleError(err, "خطا در دریافت پاسخ‌های بیمار");
  }
};
